// extracted by mini-css-extract-plugin
export var closeButton = "_iq-2";
export var closeButtonIcon = "_iq-3";
export var lightboxContent = "_iq-1";
export var lightboxOverlay = "_iq-0";